

import { Component, Emit, VModel, Vue } from 'vue-property-decorator';
import IBDialog from '@/components/Dialog/IBDialog.vue';
import { DialogVariant } from '@/components/Dialog/types';
import { Getter } from 'vuex-class';
import { IProfileEntity } from '@/models/modules/profile/interface';
import { PROFILE_MODULE_NAME } from '@/store/modules/profile';
import { PaymentRequirementsIncomingStore } from '../../store/incoming';
import { PaymentRequirementsIncomingGetter } from '../../store/incoming/constants';

@Component({
	components: {
		IBDialog
	}
})
export default class PaymentRequirementsConfirmDialog extends Vue {

	@Getter('profile', { namespace: PROFILE_MODULE_NAME })
	readonly profile!: IProfileEntity

	@PaymentRequirementsIncomingStore.Getter(
		PaymentRequirementsIncomingGetter.unprocessedCount
	)
	readonly paymentRequirementsIncomingCount!: number

	@VModel({ type: Boolean })
	model!: boolean

	get DialogVariant(): typeof DialogVariant {
		return DialogVariant;
	}

	get offerHTML(): string {
		return this.$t('paymentRequirements.offer', [
			this.paymentRequirementsIncomingCount,
			this.profile?.ulName
		]) as string;
	}

	@Emit("confirmed")
	emitConfirmed() {}

}

